export function arraySum(a: number[], b: number[], sign = 1): number[] {
    const c = [...a];
    for (let i = 0; i < Math.min(a.length, b.length); i++) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        c[i]! += sign * b[i]!;
    }
    return c;
}